import React, { CSSProperties, ReactNode } from "react";
import ButtonPushable from "../ButtonPushable/ButtonPushable";

interface ButtonPrimaryProps {
  loading: boolean;
  disabled?: boolean;
  text: string;
  onClick: (event?: any) => any;
  styles?: CSSProperties;
  className?: string;
  icon?: ReactNode;
}

const ButtonPrimary = (props: ButtonPrimaryProps) => {
  return (
    <ButtonPushable
      loading={props.loading}
      disabled={props.disabled}
      onClick={props.onClick}
      className={props.className}
    >
      <span className="flex items-center gap-2 font-poppins font-semibold text-sm">
        {props.icon && props.icon}
        {props.text}
      </span>
    </ButtonPushable>
  );
};

export default ButtonPrimary;
